if (!customElements.get('screen18-detail')) {
  customElements.define('screen18-detail', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const listen = (node, event, handler, options = {}) => node?.addEventListener(event, handler, { ...options, signal });
      const play = video => video?.play()?.catch(() => {});
      this.querySelectorAll('[data-video-toggle]').forEach(button => {
        listen(button, 'click', () => {
          const video = button.closest('.video-container')?.querySelector('video');
          if (!video) return;
          if (video.paused) play(video); else video.pause();
          button.setAttribute('aria-pressed', String(!video.paused));
        });
      });
      this.querySelectorAll('.section-technology-video').forEach(section => {
        const videos = [...section.querySelectorAll('video')];
        const trigger = section.querySelector('.js-play-trigger');
        const sound = section.querySelector('.js-sound-toggle');
        listen(trigger, 'click', () => {
          trigger.classList.add('is-hidden');
          sound?.classList.add('is-active');
          videos.forEach(video => { video.muted = false; play(video); });
        });
        listen(sound, 'click', () => {
          const active = sound.classList.toggle('is-active');
          sound.setAttribute('aria-pressed', String(active));
          videos.forEach(video => { video.muted = !active; if (active) play(video); });
          if (active) trigger?.classList.add('is-hidden');
        });
        section.querySelectorAll('.title, .content').forEach(node => { node.style.backgroundPositionX = '0%'; });
      });
      this.querySelectorAll('.ics').forEach(root => {
        const viewport = root.querySelector('.ics-slider-viewport');
        const track = root.querySelector('[data-slider-track]');
        if (!viewport || !track) return;
        const cards = [...track.querySelectorAll('.ics-card')];
        const prev = root.querySelector('[data-prev]');
        const next = root.querySelector('[data-next]');
        const progress = root.querySelector('[data-progress]');
        let position = 0;
        let gesture;
        const maximum = () => Math.max(0, track.scrollWidth - viewport.clientWidth);
        const offsets = () => [...new Set([0, ...cards.map(card => card.offsetLeft), maximum()])].sort((a, b) => a - b);
        const settle = value => {
          position = Math.max(0, Math.min(maximum(), value));
          track.style.transform = `translateX(${-position}px)`;
          if (prev) prev.disabled = position <= 1;
          if (next) next.disabled = position >= maximum() - 1;
          if (progress) progress.style.width = `${maximum() ? position / maximum() * 100 : 0}%`;
        };
        const advance = direction => settle(direction > 0
          ? offsets().find(offset => offset > position + 1) ?? maximum()
          : offsets().filter(offset => offset < position - 1).pop() ?? 0);
        listen(prev, 'click', () => advance(-1));
        listen(next, 'click', () => advance(1));
        listen(root, 'keydown', event => {
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault(); advance(event.key === 'ArrowRight' ? 1 : -1);
          }
        });
        listen(track, 'dragstart', event => event.preventDefault());
        listen(viewport, 'pointerdown', event => {
          if (event.pointerType === 'mouse' && event.button !== 0) return;
          gesture = { x: event.clientX, y: event.clientY, position, id: event.pointerId };
        }, { passive: true });
        listen(window, 'pointermove', event => {
          if (!gesture || gesture.id !== event.pointerId) return;
          const dx = event.clientX - gesture.x;
          if (Math.abs(event.clientY - gesture.y) > Math.abs(dx) && Math.abs(dx) < 8) { gesture = null; return; }
          if (Math.abs(dx) <= 8) return;
          event.preventDefault();
          track.classList.add('is-dragging');
          settle(gesture.position - dx);
        }, { passive: false });
        const end = () => {
          if (!gesture) return;
          gesture = null; track.classList.remove('is-dragging');
          settle(offsets().reduce((best, offset) => Math.abs(offset - position) < Math.abs(best - position) ? offset : best, 0));
        };
        listen(window, 'pointerup', end);
        listen(window, 'pointercancel', end);
        this.resizeObservers ||= [];
        const observer = new ResizeObserver(() => settle(position));
        observer.observe(viewport); this.resizeObservers.push(observer);
        settle(0);
      });
      this.querySelectorAll('details').forEach(details => {
        listen(details, 'toggle', () => details.querySelector('summary')?.setAttribute('aria-expanded', String(details.open)));
      });
    }
    disconnectedCallback() {
      this.controller?.abort(); this.controller = null;
      this.resizeObservers?.forEach(observer => observer.disconnect()); this.resizeObservers = [];
    }
  });
}
